<template>
  <div
    @mouseover="moused = true"
    @mouseleave="moused = false"
    class="BgVideoPlayer"
  >
    <video
      class="BgVideoPlayer__video"
      ref="videoRef"
      @click="togglePlay"
      :timeupdate="timeUpdate"
      @canplay="updatePaused"
      @playing="updatePaused"
      @pause="updatePaused"
    >
      <source :src="video" type="video/mp4" />
    </video>
    <div
      @click="togglePlay"
      :class="`BgVideoPlayer__player-holder ${
        moused && 'BgVideoPlayer__player-holder--moused'
      }`"
    >
      <div
        :class="`player ${!paused ? 'player--paused' : 'player--playing'}`"
      ></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  name: "bg-video-player",
  props: {
    video: String,
    timeUpdate: Function,
    getRef: Function,
    newScrubberTime: Number,
    propsTime: Number,
    updateMetaData: Function,
  },
  data() {
    return {
      paused: true,
      moused: false,
    };
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.keyCode == 32) {
        this.togglePlay();
      }
    });
  },
  mounted() {
    this.getRef(this.$refs.videoRef);
    this.$refs.videoRef.addEventListener("timeupdate", (e) => {
      this.timeUpdate(this.$refs.videoRef.currentTime);
    });
    this.$refs.videoRef.addEventListener("loadedmetadata", () => {
      this.updateMetaData(this.$refs.videoRef);
    });
  },
  watch: {
    propsTime(newValue) {
      this.$refs.videoRef.currentTime = newValue;
    },
    newScrubberTime(newValue) {
      this.$refs.videoRef.currentTime = newValue;
    },
  },
  methods: {
    togglePlay() {
      if (!this.$refs.videoRef.paused) {
        this.$refs.videoRef.pause();
      } else {
        this.$refs.videoRef.play();
      }
    },
    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },
  },
};
</script>
